import { isImage, isVideo, isAudio } from 'utilities/file';

class StartupCampaigns {

  constructor(basePath, apiClient) {

    this.basePath = `${basePath}/campaigns`;
    this.apiClient = apiClient;

  }

  async bootstrap(query, urlParameters) {

    const path = `${this.basePath}/bootstrap`;

    return this.apiClient.post(path, {}, {}, { query, urlParameters });

  }

  async createCampaign(campaign) {

    const path = `${this.basePath}`;

    return this.apiClient.post(path, {}, {}, campaign);

  }

  async duplicateCampaign(data) {

    const path = `${this.basePath}/duplicate`;

    return this.apiClient.post(path, {}, {}, data);

  }

  async getPaginatedCampaignsByQueryOptions(paginationOptions) {

    const path = `${this.basePath}`;

    return this.apiClient.get(path, {}, { paginationOptions });

  }

  async getPopulatedCampaignById(campaignId) {

    const path = `${this.basePath}/:campaignId`;

    return this.apiClient.get(path, { campaignId }, {});

  }

  async updateCampaignById(campaignId, data) {

    const path = `${this.basePath}/:campaignId`;

    return this.apiClient.put(path, { campaignId }, {}, data);

  }

  async updateCampaignNameById(campaignId, data) {

    const path = `${this.basePath}/:campaignId/name`;

    return this.apiClient.put(path, { campaignId }, {}, data);

  }

  async createEmptyStep(campaignId, sort) {

    const path = `${this.basePath}/:campaignId/steps`;

    return this.apiClient.post(path, { campaignId }, {}, { sort });

  }

  async duplicateStep(campaignId, campaignStepId) {

    const path = `${this.basePath}/:campaignId/steps/:campaignStepId/duplicate`;

    return this.apiClient.post(path, { campaignId, campaignStepId }, {}, {});

  }

  async updateCampaignStepTypeById(campaignId, campaignStepId, type) {

    const path = `${this.basePath}/:campaignId/steps/:campaignStepId/type`;

    return this.apiClient.put(path, { campaignId, campaignStepId }, {}, { type });

  }

  async createCampaignStepCriterion(campaignId, campaignStepId, data) {

    const path = `${this.basePath}/:campaignId/steps/:campaignStepId/conditions`;

    return this.apiClient.post(path, { campaignId, campaignStepId }, {}, data);

  }

  async updateCampaignStepCriterionById(campaignId, campaignStepId, criterionId, data) {

    const path = `${this.basePath}/:campaignId/steps/:campaignStepId/conditions/:criterionId`;

    return this.apiClient.put(path, { campaignId, campaignStepId, criterionId }, {}, data);

  }

  async deleteCampaignStepCriterionById(campaignId, campaignStepId, criterionId) {

    const path = `${this.basePath}/:campaignId/steps/:campaignStepId/conditions/:criterionId`;

    return this.apiClient.delete(path, { campaignId, campaignStepId, criterionId }, {});

  }

  async updateCampaignStepSenderById(campaignId, campaignStepId, sender) {

    const path = `${this.basePath}/:campaignId/steps/:campaignStepId/sender`;

    return this.apiClient.put(path, { campaignId, campaignStepId }, {}, sender);

  }

  async updateCampaignStepTitleById(campaignId, campaignStepId, data) {

    const path = `${this.basePath}/:campaignId/steps/:campaignStepId/title`;

    return this.apiClient.put(path, { campaignId, campaignStepId }, {}, data);

  }

  async updateCampaignStepSubjectById(campaignId, campaignStepId, data) {

    const path = `${this.basePath}/:campaignId/steps/:campaignStepId/subject`;

    return this.apiClient.put(path, { campaignId, campaignStepId }, {}, data);

  }

  async updateCampaignStepContentById(campaignId, campaignStepId, data) {

    const path = `${this.basePath}/:campaignId/steps/:campaignStepId/content`;

    return this.apiClient.put(path, { campaignId, campaignStepId }, {}, data);

  }

  async updateSendLinkedInMessageStepContentById(campaignId, campaignStepId, data) {

    const path = `${this.basePath}/:campaignId/steps/:campaignStepId/linked-in-content`;

    return this.apiClient.put(path, { campaignId, campaignStepId }, {}, data);

  }

  async updateSendTwitterMessageStepContentById(campaignId, campaignStepId, data) {

    const path = `${this.basePath}/:campaignId/steps/:campaignStepId/twitter-content`;

    return this.apiClient.put(path, { campaignId, campaignStepId }, {}, data);

  }

  async uploadCampaignStepFile(campaignId, campaignStepId, file) {

    let path = `${this.basePath}/:campaignId/steps/:campaignStepId/content`;

    if (isImage(file)) {
      path = `${path}/images`;
    } else if (isVideo(file)) {
      path = `${path}/videos`;
    } else if (isAudio(file)) {
      path = `${path}/audios`;
    }

    const data = new FormData();
    data.append('file', file);

    return this.apiClient.post(path, { campaignId, campaignStepId }, {}, data, true, false);

  }

  async updateCampaignStepReferralCampaignIdById(campaignId, campaignStepId, data) {

    const path = `${this.basePath}/:campaignId/steps/:campaignStepId/referral-campaign`;

    return this.apiClient.put(path, { campaignId, campaignStepId }, {}, data);

  }

  async updateTaskStepAssigneeIdsById(campaignId, campaignStepId, data) {

    const path = `${this.basePath}/:campaignId/steps/:campaignStepId/assignee-ids`;

    return this.apiClient.put(path, { campaignId, campaignStepId }, {}, data);

  }

  async updateTaskStepPriorityById(campaignId, campaignStepId, data) {

    const path = `${this.basePath}/:campaignId/steps/:campaignStepId/priority`;

    return this.apiClient.put(path, { campaignId, campaignStepId }, {}, data);

  }

  async updateMeetingStepAttendeesById(campaignId, campaignStepId, data) {

    const path = `${this.basePath}/:campaignId/steps/:campaignStepId/attendees`;

    return this.apiClient.put(path, { campaignId, campaignStepId }, {}, data);

  }

  async updateCalendarActivityStepRemindersById(campaignId, campaignStepId, data) {

    const path = `${this.basePath}/:campaignId/steps/:campaignStepId/reminders`;

    return this.apiClient.put(path, { campaignId, campaignStepId }, {}, data);

  }

  async updateCalendarActivityStepRecurringById(campaignId, campaignStepId, data) {

    const path = `${this.basePath}/:campaignId/steps/:campaignStepId/recurring`;

    return this.apiClient.put(path, { campaignId, campaignStepId }, {}, data);

  }

  async updateCalendarActivityStepTagsById(campaignId, campaignStepId, data) {

    const path = `${this.basePath}/:campaignId/steps/:campaignStepId/tags`;

    return this.apiClient.put(path, { campaignId, campaignStepId }, {}, data);

  }

  async updateCampaignStepWaitTimeById(campaignId, campaignStepId, data) {

    const path = `${this.basePath}/:campaignId/steps/:campaignStepId/wait-time`;

    return this.apiClient.put(path, { campaignId, campaignStepId }, {}, data);

  }

  async deleteCampaignStepByIdAndCampaignId(campaignId, campaignStepId) {

    const path = `${this.basePath}/:campaignId/steps/:campaignStepId`;

    return this.apiClient.delete(path, { campaignId, campaignStepId }, {});

  }

  async deleteCampaignById(campaignId) {

    const path = `${this.basePath}/:campaignId`;

    return this.apiClient.delete(path, { campaignId }, {});

  }

  async setCampaignLiveById(campaignId, data) {

    const path = `${this.basePath}/:campaignId/live`;

    return this.apiClient.post(path, { campaignId }, {}, data);

  }

  async pauseCampaignById(campaignId) {

    const path = `${this.basePath}/:campaignId/pause`;

    return this.apiClient.post(path, { campaignId }, {}, {});

  }

  async resumeCampaignById(campaignId) {

    const path = `${this.basePath}/:campaignId/resume`;

    return this.apiClient.post(path, { campaignId }, {}, {});

  }

  async sendTestEmail(campaignId, campaignStepId, data) {

    const path = `${this.basePath}/:campaignId/steps/:campaignStepId/test-emails`;

    return this.apiClient.post(path, { campaignId, campaignStepId }, {}, data);

  }

  async updateCampaignStepPromptById(campaignId, campaignStepId, data) {

    const path = `${this.basePath}/:campaignId/steps/:campaignStepId/prompt`;

    return this.apiClient.put(path, { campaignId, campaignStepId }, {}, data);

  }

  async getPaginatedCampaignPendingEmailsByQueryOptions(campaignId, queryOptions) {

    const path = `${this.basePath}/:campaignId/pending-emails`;

    return this.apiClient.get(path, { campaignId }, queryOptions);

  }

  async getCampaignPendingEmailById(campaignId, pendingEmailId) {

    const path = `${this.basePath}/:campaignId/pending-emails/:pendingEmailId`;

    return this.apiClient.get(path, { campaignId, pendingEmailId }, {});

  }

  async updateCampaignPendingEmailById(campaignId, pendingEmailId, data) {

    const path = `${this.basePath}/:campaignId/pending-emails/:pendingEmailId`;

    return this.apiClient.put(path, { campaignId, pendingEmailId }, {}, data);

  }

  async sendCampaignPendingEmails(campaignId, data) {

    const path = `${this.basePath}/:campaignId/pending-emails/send`;

    return this.apiClient.post(path, { campaignId }, {}, data);

  }

  async sendAllCampaignPendingEmails(campaignId, data) {

    const path = `${this.basePath}/:campaignId/pending-emails/send-all`;

    return this.apiClient.post(path, { campaignId }, {}, data);

  }

  async sendCampaignPendingEmailById(campaignId, pendingEmailId) {

    const path = `${this.basePath}/:campaignId/pending-emails/:pendingEmailId/send`;

    return this.apiClient.post(path, { campaignId, pendingEmailId }, {}, {});

  }

  async discardCampaignPendingEmailById(campaignId, pendingEmailId) {

    const path = `${this.basePath}/:campaignId/pending-emails/:pendingEmailId/discard`;

    return this.apiClient.post(path, { campaignId, pendingEmailId }, {}, {});

  }

  async regenerateCampaignPendingEmailById(campaignId, pendingEmailId) {

    const path = `${this.basePath}/:campaignId/pending-emails/:pendingEmailId/regenerate`;

    return this.apiClient.post(path, { campaignId, pendingEmailId }, {}, {});

  }

}

export default StartupCampaigns;